module.exports = __webpack_public_path__ + "img/red-square-table-4.fcf9b241.png";